import React, { useRef , useEffect} from 'react'
import AnimatedContent from "../Common/AnimatedContent";
import { HiOutlineDevicePhoneMobile } from "react-icons/hi2";
import { FaRegUser } from "react-icons/fa";
import { FaHandsHoldingCircle } from "react-icons/fa6";
import { motion } from "framer-motion";
import { useInView } from "react-intersection-observer";


const Why = () => {
     const investwithcos = useRef(null);

     useEffect(() => {
        if (window.location.hash === '#investwithcos') {
            investwithcos.current?.scrollIntoView({ behavior: 'smooth' });
        }
      }, []);
      const textVariants = {
        hidden: { opacity: 0, x: -10 },
        visible: (i) => ({
          opacity: 1,
          x: 0,
          transition: { delay: i * 0.05, duration: 0.3, ease: "easeOut" },
        }),
      };
      const { ref, inView } = useInView({
        triggerOnce: true,
        threshold: 0.2,
      });
      const text = "Why Invest in CoOwnSpace?";
      const characters = text.split("");
    

    return (
        <section ref={investwithcos} id='investwithcos' className="section-why tf-spacing-1">
                <div className="tf-container">
                    <div className="row">
                        <div className="col-12">
                            <div className="heading-section mb-48 text-center">
                            <div ref={ref} className="heading-section mb-48" style={{ whiteSpace: "nowrap" }}>
                <h2 className="title balance">
                  {characters.map((char, i) => (
                    <motion.span
                      key={i}
                      className="inline-block"
                      variants={textVariants}
                      initial="hidden"
                      animate={inView ? "visible" : "hidden"}
                      custom={i}
                    >
                      {char}
                    </motion.span>
                  ))}
                </h2>
              </div>
                                <AnimatedContent
                                    distance={5}
                                    direction="vertical"
                                    reverse={false}
                                    config={{ tension: 80, friction: 20 }}
                                    initialOpacity={0.2}
                                    animateOpacity
                                    scale={1.1}
                                    threshold={0.2}
                                >
                                    <p className="text-1 animate__fadeInUp animate__animated">
                                    CoOwnSpace makes real estate investing affordable, passive, and hassle-free. Own, earn, and grow!
                                    </p>
                                </AnimatedContent>
                            </div>
                            <div className="tf-grid-layout lg-col-4 sm-col-2 mb-46">
                                <div className="icons-box effec-icon style-2 ">
                                    <div className="tf-icon ">
                                    <HiOutlineDevicePhoneMobile style={{ width: '36px', height: '36px', color: '#FF6300' }} />

                                    </div>
                                    <h3 className="title h5 ">Easy Digital Access</h3>
                                    <p className=" text-1">Invest in real estate effortlessly through our user-friendly online platform, anytime, anywhere.
                                    </p>
                                </div>
                                <div className="icons-box effec-icon style-2 ">
                                    <div className="tf-icon ">
                                        <FaRegUser style={{ width: '36px', height: '36px', color: '#FF6300' }} />


                                    </div>
                                    <h3 className="title h5 ">Affordable Ownership</h3>
                                    <p className=" text-1">Own a fraction of premium properties without the financial burden of full ownership.</p>
                                </div>
                                <div className="icons-box effec-icon style-2 ">
                                    <div className="tf-icon ">
                                    <svg width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <defs>
                                            <linearGradient id="shieldGradient" x1="24" y1="4" x2="24" y2="44" gradientUnits="userSpaceOnUse">
                                                <stop stopColor="#FFB199" />
                                                <stop offset="1" stopColor="#FF0844" />
                                            </linearGradient>
                                        </defs>
                                        <path d="M24 4L8 10V20C8 31 16.5 38.5 24 42C31.5 38.5 40 31 40 20V10L24 4Z" />
                                        <circle cx="24" cy="20" r="6" stroke="#FFFFFF" strokeWidth="2" fill="none" />
                                        <rect x="22" y="22" width="4" height="8" fill="#FFFFFF" />
                                        <path d="M24 26C25.1046 26 26 25.1046 26 24C26 22.8954 25.1046 22 24 22C22.8954 22 22 22.8954 22 24C22 25.1046 22.8954 26 24 26Z" fill="#FFFFFF" />
                                    </svg>


                                    </div>
                                    <h3 className="title h5">Transparent & Secure</h3>
                                    <p className=" text-1">Enjoy full transparency and secure transactions for peace of mind with every investment.</p>
                                </div>
                                <div className="icons-box effec-icon style-2 ">
                                    <div className="tf-icon ">
                                    <FaHandsHoldingCircle style={{ width: '36px', height: '36px', color: '#FF6300' }} />
                                    </div>
                                    <h3 className="title h5">Hassle-Free Management</h3>
                                    <p className=" text-1">We take care of property management, so you can focus on enjoying your returns.</p>
                                </div>
                            </div>
                            {/* <p className="text-1 text-center mb-48">You can obtain more information and an appraisal of your
                                property by <a href="#">clicking this link</a> now.</p> */}
                            <a href="/property-details" className="tf-btn bg-color-primary pd-3 fw-6 mx-auto">Get Started Now</a>
                        </div>
                    </div>
                </div>
            </section>
    )
}

export default Why